/**
 * Acceso externo contador/auditor (organization_access_grants).
 * Deshabilitado en UI hasta alinear permisos backend (RPCs + sync read-only).
 * Backend/RPCs siguen en Supabase; reactivar cuando EXTERNAL_ORG_ACCESS_UI esté listo.
 */
export const EXTERNAL_ORG_ACCESS_UI_ENABLED = false;
